import React from 'react';
import { Col, Row, Typography } from 'antd';
import CardArticleLainnya from 'src/components/Card/ArticleLainnya';
import { ButtonBorderKomunitas } from 'src/components/Forms/Button';
import classes from './index.module.less';
const GeneralArticleContainer = (props: any) => {
  const dataArtikel = props?.artikel;
  const listCategory = props?.categoryArtikel;
  const queryPhase = dataArtikel.type === 'pre-pregnancy' ? 'pra-kehamilan' : dataArtikel.type === 'post-pregnancy' ? 'pasca-kehamilan' : 'kehamilan';
  const queryGroup = !dataArtikel.group_code && dataArtikel.type === 'pre-pregnancy' ? 'promil' : !dataArtikel.group_code && dataArtikel.type === 'post-pregnancy' ? 'newborn' : !dataArtikel.group_code && dataArtikel.type === 'pregnancy' ? 'trimester-1' : dataArtikel.group_code;
  const categoryExist = listCategory.some((item: any) => item.slug === dataArtikel.category_slug);
  const queryCategory = !dataArtikel.category_slug ? 'buat-mama' : dataArtikel.category_slug && categoryExist === false ? 'buat-mama' : dataArtikel.category_slug;
  return <div style={{
    backgroundColor: '#fff'
  }}>
			<Row>
				<Col md={24} sm={24} xs={24} lg={24} xl={24}>
					<div className={classes.headContact}>
						<Typography className={classes.newtitle}>Artikel Lainnya untuk Mama</Typography>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={24} sm={24} xs={24} lg={24} xl={24}>
					<CardArticleLainnya data={props.artikelLainnya} />
				</Col>
			</Row>
			<div className={classes.btnFooter}>
				<ButtonBorderKomunitas id="detail-artikel-cek-semua-artikel" href={`/artikel/${queryPhase}/${queryGroup}/${queryCategory}`} text={'Lihat Lebih Banyak'}>
				</ButtonBorderKomunitas>
			</div>
		</div>;
};
export default GeneralArticleContainer;